import React from "react";
import "./About_us.css";
import { faAngleRight } from "@fortawesome/free-solid-svg-icons";
import Common_heading from "../../common/common_heading/Common_heading";
import Common_Btn from "../../common/common-btn/Common_Btn";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useNavigate } from "react-router-dom";

function About_us() {
  const navigate = useNavigate();
  return (
    <>
      <section className="About_us">
        <div className="custom_container">
          <Common_heading
            heading={"ABOUT US"}
            subHeading={"ENGINEERING AIRFLOW. DELIVERING COMFORT."}
          />

          <div className="About_us_holder">
            <div className="row me-0 ms-0 justify-content-center ">
              <div className="col-md-4 col-sm-6">
                <div className="img_holder">
                  <img
                    src="/assets/images/home/about_us/air-conditioning.png"
                    alt="about img"
                    className="about_img"
                  />
                </div>
              </div>

              <div className="col-md-8">
                <div className="text_holder">
                  <p>
                    At AYZAIR, we specialize in delivering high-performance
                    industrial cooling solutions built to handle the toughest
                    environments. With a focus on innovation, efficiency, &
                    durability, our products are engineered to provide
                    consistent airflow and long-lasting reliability. We
                    understand that every industry has unique requirements.
                    That’s why our solutions are designed to be versatile,
                    energy-efficient, & easy to maintain ensuring optimal
                    performance across factories, warehouses, commercial spaces,
                    and more. Driven by quality and customer satisfaction, we
                    are committed to helping businesses stay cool, productive,
                    and efficient—no matter the challenge.
                  </p>

                  <div className="button_holder">
                    <Common_Btn onClick={() => navigate("/about-us")}
                      text={
                        <>
                          KNOW MORE <FontAwesomeIcon icon={faAngleRight} />
                        </>
                      }
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className="stats_holder">
              <div className="row">
                <div className="col-md-3 col-6">
                  <div className="stats_content_holder">
                    <h1>08+</h1>
                    <h3>YEARS OF   <br/> EXPERIENCE</h3>
                  </div>
                </div>

                <div className="col-md-3 col-6">
                  <div className="stats_content_holder">
                    <h1>100+</h1>
                    <h3>INDUSTRIAL  <br/> CLIENTS</h3>
                  </div>
                </div>

                <div className="col-md-3 col-6">
                  <div className="stats_content_holder">
                    <h1>5000+</h1>
                    <h3>INSTALLATIONS  <br/> COMPLETED</h3>
                  </div>
                </div>

                <div className="col-md-3 col-6">
                  <div className="stats_content_holder">
                    <h1>24/7</h1>
                    <h3>CUSTOMER  <br/> SUPPORT</h3>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default About_us;
